export default __webpack_public_path__ + "static/media/btn-mesas_letra.e542d0ae.png";